import React from 'react'
import TableSubject from '../components/TableSubject'

export default function PageSubject() {
  return (
    <React.Fragment>
      <div className="cotainerDetail">
        <TableSubject />
      </div>
    </React.Fragment>
  )
}
